module.exports = __webpack_public_path__ + "assets/img/091d8343900ebea29c27fb850279051c.png";